﻿import { useTranslation } from "../../localization/useTranslation.ts";
import { useUrlProvider } from "../../useUrlProvider.ts";
import Widget from "../Widget.tsx";
import DashboardCountCard from "../DashboardCountCard.tsx";
import { Box } from "@mui/material";
import { useTasksCountWidget } from "./TasksCountWidget.hooks.tsx";
import { taskManagementAllMyStorageKey } from "../../taskManagement/TaskManagement.hooks.ts";
import React from "react";
import LargeCountText from "../LargeCountText.tsx";
import SmallCountText from "../SmallCountText.tsx";

export interface ITasksCountWidgetProps {
    onlyUserSpecific: boolean;
    selectedGroupCompany: string | undefined;
    isPdf?: boolean;
}

function TasksCountWidget(props: ITasksCountWidgetProps) {
    const { translateString } = useTranslation();
    const { getTaskManagementUrl } = useUrlProvider();
    const { isLoading, data, isEnabled } = useTasksCountWidget(props);

    return (
        <Widget noPadding disabled={!isEnabled}>
            <DashboardCountCard
                isLoading={isLoading}
                header={translateString("tasks")}
                background="violet"
                icon="calender"
                url={{
                    url: getTaskManagementUrl("?months="),
                    text: translateString("viewTaskManagement"),
                    allMyPageKey: taskManagementAllMyStorageKey,
                    onlyUserSpecific: props.onlyUserSpecific,
                }}
                isPdf={props.isPdf}
            >
                {!isLoading && (
                    <Box sx={{ display: "flex", gap: 1, alignItems: "flex-end" }}>
                        <LargeCountText count={data?.numberOfTasksInYear} />
                        <SmallCountText>{`${translateString("in")} ${new Date().getFullYear()}`}</SmallCountText>
                    </Box>
                )}
            </DashboardCountCard>
        </Widget>
    );
}

export default TasksCountWidget;
